import React from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@linaria/react';
import { showWeb2AppPopupOverlay } from 'modules/overlay/actions';
import { Button } from '@daedalus/atlas/Button';
import { Icon } from '@daedalus/atlas/Icon';
import { getClosestDataIdToEventTarget } from '@daedalus/core/src/_web/utils/browser';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { Placement } from '@daedalus/core/src/deepLinking/types';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
const _exp = /*#__PURE__*/() => Button;
const GetTheAppWrapper = /*#__PURE__*/styled(_exp())({
  name: "GetTheAppWrapper",
  class: "g1a6k5e5",
  propsAsIs: true
});
const GetTheAppText = /*#__PURE__*/styled('span')({
  name: "GetTheAppText",
  class: "guy808t",
  propsAsIs: false
});
interface GetTheAppProps {
  dataId: string;
  placement: Placement;
}
export const GetTheApp = ({
  dataId,
  placement
}: GetTheAppProps) => {
  const dispatch = useDispatch();
  const showGetTheAppPopup = (event: React.MouseEvent) => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.AppInstallLink,
      action: Action.Clicked,
      payload: {
        selectedElement: getClosestDataIdToEventTarget(event)
      }
    }));
    dispatch(showWeb2AppPopupOverlay({
      placement
    }));
  };
  return <GetTheAppWrapper size="md" variant="secondary" isRounded dataId={dataId} iconStart={<Icon name="Iphone" colorPath="content.special.c500" />} onClick={showGetTheAppPopup}>
      <GetTheAppText>
        <FormattedMessageWrapper id="appBanner.button" defaultMessage="Get the app" />
      </GetTheAppText>
    </GetTheAppWrapper>;
};

require("./GetTheApp.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GetTheApp.tsx");